export async function delay(
  ms: number,
  ...abortSignals: ReadonlyArray<AbortSignal>
) {
  const { promise, resolve, reject } = Promise.withResolvers<void>();

  for (const abortSignal of abortSignals) {
    abortSignal.addEventListener('abort', reject);
  }

  setTimeout(() => {
    resolve();

    for (const abortSignal of abortSignals) {
      abortSignal.removeEventListener('abort', reject);
    }
  }, ms);

  await promise;
}
